import type { SVGProps } from 'react';

const SvgFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 7h-4c-.7 0-1.28-.39-1.95-.83C11.23 5.62 10.3 5 9 5H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-6c0-1.65-1.35-3-3-3M6 7h3c.7 0 1.28.39 1.95.83C11.77 8.38 12.7 9 14 9h4c.55 0 1 .45 1 1v1H5V8c0-.55.45-1 1-1m12 10H6c-.55 0-1-.45-1-1v-3h14v3c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgFolder;
